import styled from "styled-components"
import Img from "gatsby-image"

export const StyledHiAboutMeImage = styled(Img)`
  width: 100%;
  height: 100%;
  border-radius: 25px;
`
